import "./App.css";
import RootNavigation from "./navigation/root_navigation";
import { AuthProvider } from "./utils/authContext";
function App() {
  return (
    <div className="App">
      <AuthProvider>
        <RootNavigation />
      </AuthProvider>
    </div>
  );
}
export default App;
